/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

const staffApi = createApi({
  reducerPath: "staffApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getOrderCountByUserId: builder.query<any, void>({
      query: (id) => ({
        url: `/staff/chart-order-count/${id}`,
      }),
      transformResponse: (response: any) => response,
      keepUnusedDataFor: 0,
    }),
    getOrderCountOfStaff: builder.query<any, void>({
      query: (date: any) => ({
        url: `/staff/table-order-count?start=${
          date?.start?.toString() || ""
        }&end=${date?.end?.toString() || ""}`,
      }),
      transformResponse: (response: any) => response,
      keepUnusedDataFor: 0,
    }),
    getOrderCountOfStaffForChart: builder.query<any, void>({
      query: () => ({
        url: `/staff/chart-order-count`,
      }),
      transformResponse: (response: any) => response,
      keepUnusedDataFor: 0,
    }),
    getOrderCountOfUser: builder.query<any, void>({
      query: (id) => ({
        url: `staff/${id}/all-orders-count`,
      }),
      transformResponse: (response: any) => response,
      keepUnusedDataFor: 0,
    }),
    getOrderCountOfIndividualForChart: builder.query<
      {
        url: string;
      },
      {
        id: string;
        flag: string;
        to: string;
        from: string;
      }
    >({
      query: ({
        id,
        flag,
        to,
        from,
      }: {
        id: string;
        flag: string;
        to: string;
        from: string;
      }) => ({
        url: `/staff/find-individual-order-count/${id}?flag=${flag}&to=${to}&from=${from}`,
      }),
      transformResponse: (response: any) => response,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetOrderCountByUserIdQuery,
  useGetOrderCountOfStaffQuery,
  useGetOrderCountOfStaffForChartQuery,
  useGetOrderCountOfIndividualForChartQuery,
  useGetOrderCountOfUserQuery,
} = staffApi;

export default staffApi;
